// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodRecipeStepId } from './FoodRecipeStep';
import { foodEquipmentId } from './FoodEquipment';
import { z } from 'zod';
export const foodRecipeStepEquipmentId = (z.number());
export const foodRecipeStepEquipment = z.object({
    id: foodRecipeStepEquipmentId,
    recipe_step_id: foodRecipeStepId,
    equipment_id: foodEquipmentId,
    parameter_values: z.unknown().nullable(),
    created_at: z.date(),
});
export const foodRecipeStepEquipmentInitializer = z.object({
    id: foodRecipeStepEquipmentId.optional(),
    recipe_step_id: foodRecipeStepId,
    equipment_id: foodEquipmentId,
    parameter_values: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
export const foodRecipeStepEquipmentMutator = z.object({
    id: foodRecipeStepEquipmentId.optional(),
    recipe_step_id: foodRecipeStepId.optional(),
    equipment_id: foodEquipmentId.optional(),
    parameter_values: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FoodRecipeStepEquipment.js.map